'use client';

import { createPortal } from 'react-dom';
import CloseIcon from '../icons/close-icon';
import { useLocale } from 'next-intl';

const Modal = ({
  isOpen,
  onClose,
  title,
  titleIcon = <></>,
  children,
  maxWidth = '',
  headerTitleClassName = '',
  titleClassName = 'flex items-center gap-6 text-lg font-semibold',
  closeClassName = '',
  hasTitle = true,
  className = '',
}) => {
  const locale = useLocale();

  if (!isOpen) return null;

  if (typeof window === 'undefined') return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div
      onClick={handleBackdropClick}
      className='fixed inset-0 z-[9999] flex items-center justify-center bg-black/50'
    >
      <div
        className={`blue-scroll relative max-h-[95vh] w-full overflow-y-auto rounded-lg bg-white shadow-lg ${maxWidth} ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {hasTitle && (
          <div
            className={`flex items-center justify-between border-b border-b-[#EDE8E8] p-4 ${headerTitleClassName}`}
          >
            {title && (
              <h2 className={`${titleClassName}`}>
                {titleIcon}
                {title || ''}
              </h2>
            )}
            <button
              type='button'
              onClick={onClose}
              className={`cursor-pointer ${!title && 'ms-auto'}`}
              aria-label={locale === 'en' ? 'Close' : 'اغلاق'}
            >
              <CloseIcon className={`size-7 ${closeClassName}`} />
            </button>
          </div>
        )}
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
